'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventScoreRoutes = [
  {
    path: 'scores',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.score.list',
        props: true,
        component: () => import('../views/ScoreListView.vue'),
      },
      // {
      //   path: ':scoreId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.score.detail',
      //       component: () => import('../views/ScoreDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageScoreRoutes = [
  {
    path: 'scores',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.score.list',
        props: true,
        component: () => import('../views/ManageScoreListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.score.add',
        props: (route) => ({
          eventUrl: route.params.eventUrl,
          angler: parseInt(route.query.angler),
          session: parseInt(route.query.session),
        }),
        component: () => import('../views/ManageScoreAddView.vue'),
      },
      {
        path: ':scoreId',
        component: EmptyRouterView,
        props: true,
        children: [
          // {
          //   path: '',
          //   name: 'event.manage.score.detail',
          //   props: true,
          //   component: () => import('../views/ManageScoreDetailView.vue'),
          // },
          {
            path: 'edit',
            name: 'event.manage.score.edit',
            props: true,
            component: () => import('../views/ManageScoreEditView.vue'),
          },
        ],
      },
    ],
  },
];
